var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandGrabbing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.1875C10 6.7731 9.83538 6.37567 9.54235 6.08265C9.24933 5.78962 8.8519 5.625 8.4375 5.625C8.0231 5.625 7.62567 5.78962 7.33265 6.08265C7.03962 6.37567 6.875 6.7731 6.875 7.1875V9.0625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 8.4375V7.1875C13.125 6.7731 12.9604 6.37567 12.6674 6.08265C12.3743 5.78962 11.9769 5.625 11.5625 5.625C11.1481 5.625 10.7507 5.78962 10.4576 6.08265C10.1646 6.37567 10 6.7731 10 7.1875V9.6875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 11.5625V9.0625H5.3125C4.89873 9.06455 4.5025 9.22983 4.20991 9.52241C3.91733 9.815 3.75205 10.2112 3.75 10.625V11.875C3.75 13.5326 4.40848 15.1223 5.58058 16.2944C6.75269 17.4665 8.3424 18.125 10 18.125C11.6576 18.125 13.2473 17.4665 14.4194 16.2944C15.5915 15.1223 16.25 13.5326 16.25 11.875V8.4375C16.25 8.0231 16.0854 7.62567 15.7924 7.33265C15.4993 7.03962 15.1019 6.875 14.6875 6.875C14.2731 6.875 13.8757 7.03962 13.5826 7.33265C13.2896 7.62567 13.125 8.0231 13.125 8.4375V9.6875",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandGrabbing);
export default __webpack_public_path__ + "static/media/HandGrabbing.22a1bd91f6424a2c500f09eb489575aa.svg";
export { ForwardRef as ReactComponent };